import moment from 'moment'

import {
  IAPIInvoiceCustomer,
  IHICustomerDetails,
} from '../interfaces/IHealthInsurance'

export const transformAPIInvoiceCustomerToHICustomerDetails = (
  apiCustomer: IAPIInvoiceCustomer,
): IHICustomerDetails => ({
  address: apiCustomer.street || '',
  postalCode: apiCustomer.zipcode || '',
  city: apiCustomer.city || '',
  country: apiCustomer.invoice_country || '',
  healthInsuranceNumber: apiCustomer.invoice_health_insurance_number || '',
  gender: apiCustomer.gender,
  birthDay: apiCustomer.birthday || moment().format('DD-MM-YYYY'),
  extraInfo: null,
  isReadyForTable: false,
  bsnCode: null
})
